import { useState, useEffect } from 'react'
import { TextField, MenuItem, FormControl, FormHelperText, InputLabel, Select, Box, Typography, Grid } from '@mui/material'

function HealthInsurance ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    if (name === 'hasInsurance' && value === 'false') {
      onFormDataChange({ [name]: value, insuranceCompany: '', insuranceType: '' })
    } else {
      onFormDataChange({ [name]: value })
    }
  }

  useEffect(() => {
    const newErrors = {}
    if (!formData.hasInsurance.trim()) newErrors.hasInsurance = 'This field is required'
    if (formData.hasInsurance === 'true') {
      if (!formData.insuranceCompany?.trim()) newErrors.insuranceCompany = 'Insurance company is required.'
      if (!formData.insuranceType) newErrors.insuranceType = 'Please select your insurance type.'
    }
    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Health Insurance</Typography>
      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12 }}>
          <TextField
            select
            fullWidth
            label='Do you have health insurance?'
            name='hasInsurance'
            value={formData.hasInsurance || ''}
            onChange={handleChange}
            variant='outlined'
            error={showErrors && !!errors.hasInsurance}
            helperText={showErrors && errors.hasInsurance ? errors.hasInsurance : ''}
            required
          >
            <MenuItem value='true'>Yes</MenuItem>
            <MenuItem value='false'>No</MenuItem>
          </TextField>
        </Grid>

        {formData.hasInsurance === 'true' && (
          <>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Which insurance company?'
                name='insuranceCompany'
                variant='outlined'
                value={formData.insuranceCompany || ''}
                onChange={handleChange}
                error={showErrors && !!errors.insuranceCompany}
                helperText={showErrors && errors.insuranceCompany ? errors.insuranceCompany : ''}
                required
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth required error={showErrors && !!errors.insuranceType}>
                <InputLabel>Is your medical insurance a private or corporate membership?</InputLabel>
                <Select
                  value={formData.insuranceType || ''}
                  onChange={handleChange}
                  label='Is your medical insurance a private or corporate membership?'
                  name='insuranceType'
                >
                  <MenuItem value='private'>Private</MenuItem>
                  <MenuItem value='corporate'>Corporate</MenuItem>
                </Select>
                {showErrors && errors.insuranceType && <FormHelperText>{errors.insuranceType}</FormHelperText>}
              </FormControl>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  )
}

export default HealthInsurance
